import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoThreadsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogoThreads",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.248 32h-.01c-4.774-.032-8.444-1.606-10.912-4.678-2.192-2.736-3.324-6.541-3.363-11.31v-.022c.039-4.77 1.171-8.572 3.367-11.308C7.794 1.606 11.467.032 16.238 0h.02c3.66.026 6.723.966 9.1 2.797 2.237 1.721 3.812 4.173 4.679 7.29l-2.72.758c-1.472-5.28-5.197-7.978-11.072-8.02-3.879.03-6.813 1.249-8.72 3.623C5.742 8.672 4.82 11.885 4.785 16c.036 4.115.957 7.328 2.743 9.552 1.907 2.378 4.842 3.597 8.72 3.622 3.498-.025 5.811-.841 7.734-2.726 2.196-2.15 2.157-4.79 1.453-6.397-.413-.947-1.165-1.734-2.179-2.333-.256 1.802-.829 3.261-1.712 4.362-1.18 1.469-2.854 2.272-4.973 2.387-1.603.087-3.149-.291-4.345-1.069-1.418-.918-2.247-2.32-2.336-3.952-.087-1.587.544-3.046 1.772-4.108 1.175-1.015 2.826-1.61 4.778-1.722 1.437-.08 2.784-.016 4.026.189-.167-.989-.5-1.776-.999-2.343-.685-.78-1.744-1.177-3.145-1.187h-.039c-1.126 0-2.656.31-3.629 1.76l-2.342-1.571c1.306-1.94 3.424-3.008 5.971-3.008h.058c4.259.026 6.797 2.634 7.05 7.184q.215.091.428.189c1.987.934 3.44 2.349 4.205 4.093 1.062 2.428 1.162 6.387-2.064 9.545-2.467 2.413-5.46 3.504-9.702 3.533zm1.338-15.587c-.324 0-.65.01-.986.029-2.448.137-3.974 1.26-3.888 2.857.09 1.674 1.936 2.451 3.712 2.355 1.632-.086 3.757-.723 4.115-4.947a14 14 0 0 0-2.953-.294"
    })
  }));
};
LogoThreadsIcon.displayName = 'LogoThreadsIcon';